import {
  Box,
  Card,
  CardContent,
  LinearProgress,
  Typography,
  linearProgressClasses,
  styled,
} from "@mui/material";
import React, {useEffect, useState} from "react";

const StyledTimerContainer = styled(Card)(({theme}) => ({
  position: "relative",
  width: "400px",
  padding: "16px 16px",
  backgroundColor: "white",
}));

const StyledTimerContent = styled(CardContent)(
  ({theme}) => `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0 10px;
   & > div > p {
      font-size: 24px;
      font-weight: 600;
      margin-right: 24px;
      vertical-align: middle;
  },
  `
);
const TimeDisplay = styled(Box)(({theme}) => ({
  display: "flex",
  alignItems: "center",
  gap: "0 10px",
  "& p": {
    fontSize: "36px",
    fontWeight: 700,
  },
}));
const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
  height: 8,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.mode === "light" ? "#01579B;" : "#01579B",
  },
}));

type TimerProps = {
  execution: () => void;
};

const Timer = ({execution}: TimerProps) => {
  const inputMinutes = 30; // 30분 고정
  const wholeTimes = inputMinutes * 60;
  const [time, setTime] = useState(inputMinutes * 60);
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);

  useEffect(() => {
    if (time > 0) {
      const timer = setInterval(() => {
        setTime((prevTime) => prevTime - 1); // <-- Change this line!
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    } else {
      execution();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [time]);
  return (
    <React.Fragment>
      <StyledTimerContainer>
        <StyledTimerContent>
          <Box display="flex" alignItems="center">
            <Typography>평가시간 </Typography>
            <TimeDisplay>
              <Typography color={minutes < 1 && seconds < 30 ? "secondary" : "#01579B"}>
                {minutes < 10 ? `0${minutes}` : minutes}
              </Typography>
              <Typography color={minutes < 1 && seconds < 30 ? "secondary" : "#01579B"}>
                :
              </Typography>
              <Typography color={minutes < 1 && seconds < 30 ? "secondary" : "#01579B"}>
                {seconds < 10 ? `0${seconds}` : seconds}
              </Typography>
            </TimeDisplay>
          </Box>
        </StyledTimerContent>
        <Box>
          <BorderLinearProgress variant="determinate" value={(time / wholeTimes) * 100} />
        </Box>
      </StyledTimerContainer>
    </React.Fragment>
  );
};

export default Timer;
